import type { ComponentProps } from "react";
import { parseDate, DatePicker as PrimitiveDatePicker } from "@ark-ui/react";
import Control from "./Control/Control";
import Content from "./Content/Content";
import Input from "./Input/Input";
import Label from "./Label/Label";
import { DatePickerProvider, type DatePickerColor } from "./DatePickerContext";
import Wrapper from "./Content/Wrapper";
import DayView from "./Content/DayView";
import MonthView from "./Content/MonthView";
import YearView from "./Content/YearView";

type Props = Omit<ComponentProps<typeof PrimitiveDatePicker.Root>, "value" | "defaultValue"> & {
  color?: DatePickerColor;
  value?: string[] | Date[];
  defaultValue?: string[] | Date[];
  required?: boolean;
};

const DatePickerRoot = ({
  children,
  selectionMode,
  value: _value,
  defaultValue: _defaultValue,
  color = "primary",
  required = false,
  readOnly = false,
  ...rest
}: Props) => {
  const value = _value ? parseDate(_value) : _value;
  const defaultValue = _defaultValue ? parseDate(_defaultValue) : _defaultValue;

  return (
    <DatePickerProvider color={color} readOnly={readOnly} required={required} mode={selectionMode ?? "single"}>
      <PrimitiveDatePicker.Root
        fixedWeeks
        selectionMode={selectionMode}
        data-mode={selectionMode}
        value={value}
        defaultValue={defaultValue}
        {...rest}
      >
        {children}
      </PrimitiveDatePicker.Root>
    </DatePickerProvider>
  );
};

export const DatePicker = Object.assign(DatePickerRoot, {
  Control,
  Content,
  Input,
  Label,
  Wrapper,
  DayView,
  MonthView,
  YearView,
});
